import React, {Component} from 'react';
import settings from '../../utils/settings';
import noImageAvailable from '../../styles/images/no-image-available.png';
import ReactTooltip from 'react-tooltip';
import {findDOMNode} from 'react-dom'
import GeoUtils from '../../utils/geoUtils';
import IPUtils from '../../utils/ipv4Utils';
import urlHandler from '../../utils/urlHandler';

class SegmentWithTooltip extends Component {
    constructor(props) {
        super(props);

        this.formatCSSClass = this.formatCSSClass.bind(this);
        this.fetchEntities = this.fetchEntities.bind(this);
        this.renderContents = this.renderContents.bind(this);
        this.imageError = this.imageError.bind(this);
        this.handleFeedback = this.handleFeedback.bind(this);

        this.uniqueId = 'id-' + Math.random().toString(36).substr(2, 16);
        this.bbcId = 'bbc-' + this.uniqueId;
        this.externalUrlsDisable = window._externalUrlsDisable;
        this.availableStyles = {
            'organization': 'organization',
            'geo': 'geo',
            'person': 'person',
            'email': 'email',
            'uri': 'uri',
            'datetime': 'datetime',
            'group': 'groupType',
            'money': 'money',
            'payment': 'payment',
            'other': 'other',
            'phone': 'phone',
            'position': 'position',
            'nationality': 'nationality',
            'ethnicity': 'ethnicity',
            'language': 'language',
            'twitter': 'twitter',
            'ipv4': 'ipv4',
            'ticker': 'ticker',
            'acronym': 'acronym',
            'thing': 'thing',
            'measurement': 'measurement',
            'quote': 'quote',
            'thing/event': 'event',
            'thing/facility': 'facility',
        };
        this.state = {
            showBaseballCard: false,
            baseballcard: null,
        }
    }

    componentDidMount() {
        if (this.props.segment) {
            this.fetchEntities(this.props.segment);
        }
    }

    fetchEntities(segment) {
        let entities = segment.entities;
        let sentiment = null;
        if (!this.state.baseballcard && entities && entities.length > 0) {

            if ('mention' in entities[0]) {
                if ('sentiment' in entities[0].mention) {
                    sentiment = entities[0].mention.sentiment;
                }
            }

            let salienceScore = null;
            if ('salienceScore' in entities[0]) {
                salienceScore = entities[0].salienceScore;
            }

            if(entities[0].disambiguationResults
                && entities[0].disambiguationResults.length > 0
                && entities[0].disambiguationResults[0]) {

                if (entities[0].disambiguationResults[0].id) {
                    // urlHandler.sendRequest('entities2', null, entities[0].disambiguationResults[0].id, null, null, (response,txt,status) => {
                    //     if (status == 200) {
                    const response = this.props.getEntityData(entities[0].disambiguationResults[0].id)
                            var imageUrls = response.imageUrls ? response.imageUrls : [];
        
                            // Use geo information from the entities lookup
                            var geoEnclosingReg = GeoUtils.getEnclosingRegion(response);
                            var geoPopulation = GeoUtils.getPopulation(response);
                            var geoCoords = GeoUtils.getCoordinates(response);

                            // Gather some org information if available
                            var inst = null;
                            if ('instanceOf' in response && response.instanceOf.length > 0) {
                                inst = response.instanceOf[0];
                            }
                            var stockExchange = null;
                            var stockTicker = null;
                            if ('stocks' in response && response.stocks.length > 0) {
                                stockExchange = response.stocks[0].operatingMic || response.stocks[0].exchange || null;
                                stockTicker = response.stocks[0].tickerSymbol || null;
                            }

                            // Handle language specific label and description fields
                            var label = entities[0].normalizedText || response.label;
                            var description = response.dsgFeatureCodeLabel || response.description;
                            var urls = response.urls;
                            if ('languageFields' in response) {
                                var selectedLang = settings.getValue('languageCode','en');
                                var forceEnglish = settings.getValue('forceEnglish', true);
                                response.languageFields.forEach(function (arrayItem) {
                                    if ('langCode' in arrayItem && arrayItem.langCode === selectedLang && !forceEnglish) {
                                        if ('label' in arrayItem) {
                                            label = arrayItem.label;
                                        }
                                        if ('description' in arrayItem) {
                                            description = arrayItem.description;
                                        }
                                        if ('urls' in arrayItem) {
                                            arrayItem.urls.forEach(function(urlItem) {
                                                urls.unshift(urlItem);
                                            });
                                        }
                                    }
                                });
                            }

                            this.setState({
                                showBaseballCard: true,
                                baseballcard: {
                                    label,
                                    description,
                                    imageUrls: response.imageUrls,
                                    urls,
                                    extractionConfidence: entities[0].extractionConfidence || null,
                                    score: entities[0].disambiguationResults[0].score || null,
                                    enclosingRegion: geoEnclosingReg,
                                    population: geoPopulation,
                                    coordinates: geoCoords,
                                    orgInstanceOf: inst,
                                    orgStockExchange: stockExchange,
                                    orgStockTicker: stockTicker,
                                    sentiment,
                                    finchId: response.id || null,
                                    permIds: response.permIds || null,
                                    spgId: response.spgId || null,
                                    moneyAmount: null,
                                    salienceScore
                                },
                                imageUrls
                            });
                        
                    // })

                } else {

                    // Fallback to using GEO information from the disambiguation response if we cannot do a 
                    // entities lookup
                    var geoEnclosingReg = GeoUtils.getEnclosingRegion(entities[0].disambiguationResults[0].attributes);
                    var geoPopulation = GeoUtils.getPopulation(entities[0].disambiguationResults[0].attributes);
                    var geoCoords = GeoUtils.getCoordinates(entities[0].disambiguationResults[0].attributes);     

                    this.setState({
                        showBaseballCard: true,
                        baseballcard: {
                            label: entities[0].normalizedText || '',
                            description: entities[0].type || '',
                            extractionConfidence: entities[0].extractionConfidence || null,
                            enclosingRegion: geoEnclosingReg,
                            population: geoPopulation,
                            coordinates: geoCoords,
                            sentiment,
                            moneyAmount: null,
                            salienceScore
                        }
                    });              
                }

            } else {

                let ipRegion = IPUtils.getIpRegion(entities[0]);
                let ipCoords = IPUtils.getIpCoordinates(entities[0]);
                var label = entities[0].normalizedText || '';
                var moneyAmount = null;

                // Handle money, which is not disambiguated
                if (entities[0].type && entities[0].type == 'MONEY') {
                    if ('attributes' in entities[0] && 'normalizedAmount' in entities[0]['attributes']) {
                        moneyAmount = entities[0]['attributes'].normalizedAmount;
                    }
                }

                this.setState({
                    showBaseballCard: true,
                    baseballcard: {
                        label,
                        description: entities[0].type || '',
                        extractionConfidence: entities[0].extractionConfidence || null,
                        enclosingRegion: ipRegion,
                        coordinates: ipCoords,
                        sentiment,
                        moneyAmount,
                        salienceScore
                    }
                })
            }
        }
    };

    formatCSSClass (entityType) {
        if(this.availableStyles[entityType]){
            return this.availableStyles[entityType];
        }
        let parts = entityType.split(/[_\/]/);
        const cssClassName = (parts.length === 3 && parts[2].toLowerCase() === 'ticker') ? parts[2].toLowerCase() : parts[0].toLowerCase();
        return this.availableStyles[cssClassName] ? this.availableStyles[cssClassName] : 'other';
    };

    imageError({currentTarget}){
        const set = new Set(this.state.imageUrls);
        const newArray = Array.from(set);
        if(newArray.indexOf(currentTarget.src) < newArray.length-1){
            currentTarget.src=newArray[newArray.indexOf(currentTarget.src)+1]
        }
        else{
            ReactTooltip.hide();
            this.setState({imageUrls: []})
        }
    }

    handleFeedback(segment, e) {
        ReactTooltip.hide();
        this.props.handleFeedback(segment);
    }

    renderContents() {

        let sentiment_class = '';
        if (this.state.baseballcard && this.state.baseballcard.sentiment) {
            if (this.state.baseballcard.sentiment.class) {
                sentiment_class = 'bbc-sentiment-' + this.state.baseballcard.sentiment.class;
            }
        }

        if (this.state.baseballcard) {
            return(
                <div className="bbc" ref={this.bbcId}>
                    <div className="bbc-header">
                        <div className="bbc-label">{this.state.baseballcard.label} 
                            <span hidden={!this.state.baseballcard.orgInstanceOf} className="bbc-org-instance"> ({this.state.baseballcard.orgInstanceOf})</span>
                        </div>
                        {this.state.baseballcard.enclosingRegion &&
                            <div className="bbc-region">({this.state.baseballcard.enclosingRegion})</div>
                        }            
                    </div>
                    <div className="bbc-description">
                        {this.state.imageUrls && !this.externalUrlsDisable &&
                            <img src={this.state.imageUrls[0]} onError={this.imageError}/>
                        }
                        <div>{this.state.baseballcard.description}</div>
                        <div className="bbc-extra">
                            {this.state.baseballcard.population &&
                                <div>Population: {this.state.baseballcard.population}</div>
                            }  
                            {this.state.baseballcard.coordinates &&
                                <div>Coordinates: {this.state.baseballcard.coordinates}</div>
                            }      
                            {this.state.baseballcard.orgStockExchange && this.state.baseballcard.orgStockTicker &&
                                <div>({this.state.baseballcard.orgStockTicker}) {this.state.baseballcard.orgStockExchange}</div>
                            }  
                            {this.state.baseballcard.moneyAmount &&
                                <div>Amount: {this.state.baseballcard.moneyAmount}</div>
                            }                  
                        </div>
                    </div>
                    {this.state.baseballcard.sentiment &&
                        <div className={sentiment_class}>
                            <div className="bbc-meta-entry">Sentiment Class: {this.state.baseballcard.sentiment.class}</div>
                            {(this.state.baseballcard.sentiment.score !== undefined) &&
                                <div className="bbc-meta-entry">Sentiment Score: {this.state.baseballcard.sentiment.score.toFixed(4)}</div>
                            }
                            {this.state.baseballcard.sentiment.classConfidence &&
                                <div className="bbc-meta-entry">Sentiment Confidence: {this.state.baseballcard.sentiment.classConfidence.toFixed(4)}</div>
                            }
                            {('topic' in this.state.baseballcard.sentiment) &&
                                <div className="bbc-meta-entry">Topic: {this.state.baseballcard.sentiment.topic}</div>
                            }
                        </div>
                    }
                    <div className="bbc-meta">
                        <div className="bbc-meta-entry-wrapper">
                            {this.state.baseballcard.extractionConfidence &&
                                <span className="bbc-meta-entry">
                                    <div>Extraction Confidence: {this.state.baseballcard.extractionConfidence.toFixed(4)}</div>
                                </span>
                            }
                            {this.state.baseballcard.finchId &&
                                <span className="bbc-meta-entry">
                                    <div>Finch Id: {this.state.baseballcard.finchId}</div>
                                </span>
                            }
                            {this.state.baseballcard.score &&
                                <span className="bbc-meta-entry">
                                    <div>Disambiguation Score: {this.state.baseballcard.score.toFixed(4)}</div>
                                </span>
                            }
                            {this.state.baseballcard.permIds &&
                                <span className="bbc-meta-entry">
                                    <div>Perm Id:&nbsp; 
                                        {this.state.baseballcard.permIds.map(function(permid, idx) {
                                            return <span key={idx}>{permid}<br/></span>
                                        })} 
                                    </div>
                                </span>
                            }
                            {this.state.baseballcard.spgId &&
                                <span className="bbc-meta-entry">
                                    <div>S&amp;P Global Id: {this.state.baseballcard.spgId}</div>
                                </span>
                            }
                            {('salienceScore' in this.state.baseballcard && this.state.baseballcard.salienceScore != null) &&
                                <span className="bbc-meta-entry">
                                    <div>Salience Score: {this.state.baseballcard.salienceScore.toFixed(4)}</div>
                                </span>
                            }
                        </div>
                    </div>
                </div>
            )
        } else {
            return (<div></div>);
        }
    }

    render() {
        const {segment} = this.props;

        const entities = segment.entities || [];
        const hasEntities = (entities.length > 0);

        const entityType = hasEntities ? entities[0].type.toLowerCase() : '';
        const cssClassName = hasEntities ? this.formatCSSClass(entityType) : 'untagged';
        
        const showCard = entities && entities.length > 0;

        return(
            <span className={ 'tagged-with ' + cssClassName }>
                {showCard ?
                    <span 
                        style={{cursor:'pointer', whiteSpace: 'pre-wrap'}}
                        data-tip
                        data-for={this.uniqueId} 
                        ref={this.uniqueId} 
                        onMouseUp={this.handleFeedback.bind(this, segment)}>
                        {segment.text}
                    </span>
                    : <span style={{whiteSpace: 'pre-wrap'}}>{segment.text}</span>
                }
                <ReactTooltip id={this.uniqueId} 
                        type='dark' 
                        effect='solid' 
                        place='right'
                        delayShow={300} 
                        delayHide={150}
                        delayUpdate={150}
                        class='bbc-base'>
                    { this.renderContents() }
                </ReactTooltip>
{/* 
                <a data-for='overTime' data-tip>=( •̀д•́)</a>
                <ReactTooltip id='overTime' getContent={[() => {
                return 'Random length content'.slice(0, Math.floor(Math.random() * 21) + 1)
                }, 1000]}/> */}
            </span>
        )
    }
}

export default SegmentWithTooltip;